import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Hero.css';

const Hero = () => {
  const linesRef = useRef(null);
  const particlesRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Create animated hero lines
    if (linesRef.current) {
      for (let i = 0; i < 6; i++) {
        const line = document.createElement('div');
        line.className = 'hero__line';
        line.style.left = `${15 + i * 14}%`;
        line.style.animationDelay = `${i * 0.8}s`;
        line.style.animationDuration = `${6 + Math.random() * 4}s`;
        linesRef.current.appendChild(line);
      }
    }

    // Create floating particles
    if (particlesRef.current) {
      for (let i = 0; i < 20; i++) {
        const p = document.createElement('div');
        p.className = 'particle';
        p.style.left = `${Math.random() * 100}%`;
        p.style.animationDuration = `${8 + Math.random() * 12}s`;
        p.style.animationDelay = `${Math.random() * 10}s`;
        const size = `${1 + Math.random() * 2}px`;
        p.style.width = size;
        p.style.height = size;
        particlesRef.current.appendChild(p);
      }
    }
  }, []);

  return (
    <section className="hero">
      <div className="hero__gradient" />
      <div className="hero__lines" ref={linesRef} />
      <div className="particles" ref={particlesRef} />

      <div className="hero__content">
        <div className="hero__badge">⚡ Agencia Digital</div>
        <h1 className="hero__title">
          IMPULSA TU
          <span className="hero__title-accent">PRESENCIA</span>
          <span className="hero__title-filled">DIGITAL</span>
        </h1>
        <p className="hero__subtitle">
          Desde la creación de sitios web cautivadores hasta el desarrollo de
          aplicaciones personalizadas, nuestro equipo se especializa en materializar
          tus ideas digitales.
        </p>
        <div className="hero__buttons">
          <button 
            className="btn-primary" 
            onClick={() => navigate('/contacto')}
            aria-label="Comenzar ahora y contactar con la agencia"
          >
            Comenzar Ahora
          </button>
          <button 
            className="btn-outline"
            aria-label="Ver nuestros proyectos realizados"
          >
            Ver Proyectos
          </button>
        </div>
        {/* <div className="hero__scroll">
          <span>Scroll</span>
          <div className="hero__scroll-line" />
        </div> */}
      </div>


    </section>
  );
};

export default Hero;
